import React from 'react';

export const AfterPayBanner = ({currencyCode='USD'}) => {

    const urlPrefix = window.location.hostname === 'localhost' ? 'http://localhost:8080' : '';
    const staticUrl = urlPrefix + '/apps/jcom/s4/src/images/payment-logos/';

    return (
        <div className="afterpay-banner-container">
            <div className="dollar-icon-container">
                <div className="dollar-icon-wrapper">
                    <img className="image dollar-image" src={staticUrl + 'DollarIcon.png'} />
                    <div className="flexible-payment-options">Flexible Payment Options</div>
                </div>
                <div className="black-arrow" />
            </div>

            <div className="payment-options">
                <img className="image" src={staticUrl + 'Visa_card.png'} alt="Visa Card Logo" />
                <img className="image" src={staticUrl + 'Mastercard_card.png'} alt="Mastercard Card Logo" />
                <img className="image" src={staticUrl + 'AMEX_card.png'} alt="American Express Card Logo" />
                <img className="image" src={staticUrl + 'Discover_card.png'} alt="Discover Card Logo" />
                <img className="image" src={staticUrl + 'Apple_Pay_Mark_RGB_041619.svg'} alt="ApplePay Logo" />
                <div className="image-container">
                    <img className="image" src={staticUrl + 'CashAfterGreen.png' } alt="Afterpay Logo" />
                    <img className="image" src={staticUrl + 'paypal-seeklogo.png' } alt="PayPal Logo"/>
                </div>
            </div>
        </div>
    );
}
